import React from 'react';
import { Mic, Pen } from 'lucide-react';
import { cn } from '../../../../lib/utils';
import { VoiceRecorder } from '../../../shared/VoiceRecorder';

interface ActionButtonsProps {
  isRecording: boolean;
  recordingTime: number;
  maxRecordingTime: number;
  recordingError: string | null;
  onVoiceMessage: () => void;
  onCreateNote: () => void;
  onCancelRecording: () => void;
}

export function ActionButtons({
  isRecording,
  recordingTime,
  maxRecordingTime,
  recordingError,
  onVoiceMessage,
  onCreateNote,
  onCancelRecording
}: ActionButtonsProps) {
  return (
    <div className="fixed bottom-7 right-7 flex gap-3 z-30">
      {/* Voice recorder error message */}
      {recordingError && (
        <div className="absolute bottom-full right-0 mb-2 w-80">
          <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-red-600 text-sm">
            {recordingError}
          </div>
        </div>
      )}

      {/* Voice recorder UI */}
      <VoiceRecorder
        isRecording={isRecording}
        recordingTime={recordingTime}
        maxRecordingTime={maxRecordingTime}
        onCancel={onCancelRecording}
      />

      {/* Voice button */}
      {!isRecording && (
        <button
          onClick={onVoiceMessage}
          className={cn(
            'h-10 w-10 rounded-full shadow-md transition-colors flex items-center justify-center',
            'bg-green-500 text-white hover:bg-green-600'
          )}
          title="Record voice note"
        >
          <Mic size={20} />
        </button>
      )}

      {/* New note button */}
      {!isRecording && (
        <button
          onClick={onCreateNote}
          className="h-10 w-10 rounded-full shadow-md bg-blue-500 text-white hover:bg-blue-700 transition-colors flex items-center justify-center"
          title="Create new note"
        >
          <Pen size={20} />
        </button>
      )}
    </div>
  );
}